// live (production) environment - frontend of central.mediatex.sk; development features are hidden there
export const isLive = (process.env.REACT_APP_API_URL ?? window.location.host).includes('central.mediatex.sk')
